import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { OwnerFields, emptyOwner, findOwnerDuplicates, DuplicateOwnerDialog } from "@/components/OwnerFields";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";

export const OwnerDialog = ({ open, onOpenChange, owner, onSaved, onCreatedAddDog }) => {
  const editing = !!owner;
  const [form, setForm] = useState(emptyOwner);
  const [owners, setOwners] = useState([]);
  const [saving, setSaving] = useState(false);
  const [dupMatches, setDupMatches] = useState([]);
  const [pendingAddDog, setPendingAddDog] = useState(false);

  useEffect(() => {
    if (open) {
      setForm(owner ? { ...emptyOwner, ...owner } : emptyOwner);
      setDupMatches([]);
      setPendingAddDog(false);
      api.get("/owners").then((r) => setOwners(r.data)).catch(() => {});
    }
  }, [open, owner]);

  const doSave = async (thenAddDog) => {
    setSaving(true);
    try {
      const res = editing ? await api.put(`/owners/${owner.id}`, form) : await api.post("/owners", form);
      toast.success(editing ? "Cliente aggiornato" : "Cliente creato");
      onSaved?.(res.data);
      onOpenChange(false);
      if (!editing && thenAddDog) onCreatedAddDog?.(res.data);
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setSaving(false);
    }
  };

  const submit = async (thenAddDog, force = false) => {
    if (!form.nome.trim()) return toast.error("Il nome è obbligatorio.");
    if (!editing && !force) {
      const dups = findOwnerDuplicates(owners.filter((o) => o.id !== owner?.id), form);
      if (dups.length) { setPendingAddDog(thenAddDog); setDupMatches(dups); return; }
    }
    await doSave(thenAddDog);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto wg-scroll">
        <DialogHeader>
          <DialogTitle className="font-head">{editing ? "Modifica cliente" : "Nuovo cliente"}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <OwnerFields form={form} setForm={setForm} tid="owner" />
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button data-testid="owner-save" onClick={() => submit(false)} disabled={saving}>{saving ? "Salvataggio…" : "Salva"}</Button>
          {!editing && <Button data-testid="owner-save-add-dog" variant="secondary" onClick={() => submit(true)} disabled={saving}>Salva e aggiungi cane</Button>}
        </DialogFooter>
      </DialogContent>
      <DuplicateOwnerDialog
        matches={dupMatches}
        onUse={(m) => { const t = pendingAddDog; setDupMatches([]); onOpenChange(false); if (t) onCreatedAddDog?.(m); else onSaved?.(m); }}
        onCreateAnyway={() => { const t = pendingAddDog; setDupMatches([]); submit(t, true); }}
        onCancel={() => setDupMatches([])}
      />
    </Dialog>
  );
};
